import { Link } from "wouter";
import { BrandLogo } from "@/components/brand-logo";
import { ThemeToggle } from "@/components/theme-toggle";

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="max-w-3xl mx-auto px-6 min-h-[5.25rem] py-2 flex items-center justify-between gap-4">
          <Link href="/" className="inline-flex min-w-0 max-w-full flex-1 items-center">
            <BrandLogo variant="nav" />
          </Link>
          <ThemeToggle />
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10 space-y-8">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Terms of Service</h1>
          <p className="text-sm text-muted-foreground mt-2">Last updated: April 6, 2026</p>
        </div>
        <div className="space-y-4 text-sm text-muted-foreground leading-relaxed">
          <p>
            These Terms of Service govern your use of TeachersHub. This page is a placeholder and should
            be replaced with terms reviewed by qualified counsel for your business and region.
          </p>
          <h2 className="text-base font-semibold text-foreground pt-2">Use of the service</h2>
          <p>
            You agree to use the service only for lawful purposes and in accordance with these terms and
            any policies we publish.
          </p>
          <h2 className="text-base font-semibold text-foreground pt-2">Accounts</h2>
          <p>
            You are responsible for maintaining the security of your account and for activity that
            occurs under your account.
          </p>
          <h2 className="text-base font-semibold text-foreground pt-2">Disclaimer</h2>
          <p>
            The service is provided &quot;as is&quot; to the extent permitted by law. Limitations of liability
            and dispute resolution should be spelled out in your final legal documents.
          </p>
        </div>
        <p>
          <Link href="/" className="text-sm text-primary hover:underline">
            ← Back to home
          </Link>
        </p>
      </main>
    </div>
  );
}
